import { z } from "zod";
import type { SectionDef } from "./_types";

const BillingShape = {
  member_unit_price:   z.number().positive(),
  prospect_unit_price: z.number().nonnegative(),
  minimum_fee:         z.number().nonnegative(),
  billing_day:         z.number().int().min(1).max(28),
  due_offset_days:     z.number().int().min(0).max(60),
  currency:            z.enum(["BRL", "USD"]),
};

export const BILLING_DEFAULTS = {
  member_unit_price:   7,
  prospect_unit_price: 0,
  minimum_fee:         1500,
  billing_day:         1,
  due_offset_days:     10,
  currency:            "BRL" as const,
};

export type BillingValues = z.infer<z.ZodObject<typeof BillingShape>>;

export const billing = {
  schema: z.object(BillingShape),
  defaults: BILLING_DEFAULTS,
  meta: {
    member_unit_price:   { label: "Member unit price (R$)",   group: "pricing", widget: "number" },
    prospect_unit_price: { label: "Prospect unit price (R$)", group: "pricing", widget: "number" },
    minimum_fee:         { label: "Minimum fee (R$)",         group: "pricing", widget: "number" },
    billing_day:         { label: "Billing day (1-28)",       group: "schedule", widget: "number" },
    due_offset_days:     { label: "Due offset (days)",        group: "schedule", widget: "number" },
    currency:            { label: "Currency",                 group: "pricing", widget: "select" },
  },
  forbiddenLiterals: [],
} as const satisfies SectionDef<typeof BillingShape>;
